import routes from '@/data/routesWithoutDefaultPath';

const menu = {
  sales: [
    {
      text: 'Traffic Details',
      icon: 'pie_chart',
      to: { name: 'traffic_details' },
    },
    {
      text: 'Traffic Analysis ',
      icon: 'bar_chart',
      to: { name: 'traffic_analysis' },
    },
    {
      text: 'Settings',
      icon: 'fa-wrench',
      to: { name: 'settings' },
    },
  ],
  support: [
    {
      text: 'Transactions',
      icon: 'list',
      to: { name: 'transactions' },
    },
  ],
};

const mapPermissions = (menuArray, routesArray) => {
  menuArray.forEach(item => {
    if (item.children) {
      mapPermissions(item.children, routesArray);
    } else {
      const matchedRoute = routesArray.find(route => {
        return item.to.name === route.name;
      });
      // eslint-disable-next-line no-param-reassign
      item.permissions = matchedRoute.meta.requiresPermissions;
    }
  });
};

const routeItems = [].concat(...Object.values(routes));
const menuItems = [].concat(...Object.values(menu));

mapPermissions(menuItems, routeItems);

export default menu;
